// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"16c03651","750":"7261e938"}[chunkId] + ".chunk.css";
};